export const UTM_CONTENT = {
  title: 'nadpis',
  button: 'tlacitko'
}
